export var AllGradesOption = {
    'id': 'all-grades',
    'name': 'all-grades',
    'labelText': 'All grades'
};
